export interface EquipmentUsageOverviewDetail {
  equipmentDispatchID: string;
  equipmentID: string;
  shift: number;
  billingRate?: number;
  unitName: string;
  customerPO?: string;
  workOrder: string;
  workOrderDescription: string;
  billingTemplate?: string;
  equipmentBillingID?: string;
  datesUsed: Date[];
  totalQuantity: number;
  totalCost: number;
}
